import { Button, FieldLabel } from 'ca-ui';
import { VRAssetPicker } from './asset-picker.js';

export class VREditorSubPanel {
  constructor (vr, editor, panelOpts) {
    this.vr = vr;
    this.editor = editor;
    this.panelOpts = panelOpts;

    this.id = panelOpts.id;
    this.item = $(
      '<li class="ca-vr_editorpanel-menu_' + panelOpts.id + '"></li>'
    );

    this.itemLabel = $(
      '<label class="ca-vr_editorpanel-menu_label">' +
        panelOpts.name +
        '</label>'
    );
    this.item.append(this.itemLabel);

    this.panel = $(
      '<div class="ca-vr_editorpanel_subpanel ca-vr_editorpanel_subpanel-' +
        panelOpts.id +
        '"></div>'
    );
    this.item.append(this.panel);

    // Instructions
    if (panelOpts.instructions) {
      this.label = $('<label>' + panelOpts.instructions + '</label>');
      this.panel.append(this.label);
    }

    // Select
    if (panelOpts.assets) this.initSelect();

    // Preview
    if (panelOpts.preview) this.initPreview();

    // Other
    this.initControls();
    if (panelOpts.assets) {
      // Add button
      if (panelOpts.allowAddAsset) {
        this.addButton = new Button({
          label: panelOpts.addAssetButtonLabel,
          primary: true
        });
        this.addButton.on(
          'click',
          function () {
            editor.select(this.newObject());
            if (this.panelOpts.initialAsset !== undefined) {
              this.panelOpts.onAssetChange.call(this, panelOpts.initialAsset);
            } else {
              if (this.panelOpts.onAssetChange !== undefined) {
                this.panelOpts.onAssetChange.call(this, panelOpts.assets[0]);
              }
            }
          }.bind(this)
        );
        this.panel.append(this.addButton.el);
      }

      // Delete
      this.deleteContainer = new FieldLabel({ label: 'Delete?' });
      this.deleteContainer.el.css('margin-top', 30);
      this.deleteContainer.el.css('padding-top', 25);
      this.deleteContainer.el.css('border-top', '1px solid #00000021');
      this.deleteContainer.hide();
      this.panel.append(this.deleteContainer.el);

      this.deleteButton = new Button({
        label: 'Delete',
        icon: 'trash',
        danger: true
      });
      this.deleteButton.el.css('border', '1px solid #ea879180');
      this.deleteButton.el.css('color', '#dc6e79');
      this.deleteContainer.setField(this.deleteButton);

      this.deleteButton.on(
        'click',
        function () {
          editor.deleteObject(this.getObject());
          this.setObject(null);
        }.bind(this)
      );

      // Default
      if (this.panelOpts.onAssetChange) {
        if (this.panelOpts.initialAsset !== undefined) {
          this.panelOpts.onAssetChange.call(this, panelOpts.initialAsset);
        } else {
          this.panelOpts.onAssetChange.call(this, panelOpts.assets[0]);
        }
      }
    }
  }

  initSelect () {
    // Type
    this.typeLabel = $(
      '<label>' + this.panelOpts.assetSelectLabel + '</label>'
    );
    this.typeLabel.hide();
    this.panel.append(this.typeLabel);

    this.assetSelect = $('<select></select>');
    this.assetSelect.hide();
    this.assetSelect.change(
      function () {
        const index = this.assetSelect.prop('selectedIndex');
        const asset = this.panelOpts.assets[index];
        if (this.panelOpts.onAssetChange) { this.panelOpts.onAssetChange.call(this, asset); }
      }.bind(this)
    );
    this.panel.append(this.assetSelect);

    this.panelOpts.assets.forEach(
      function (a) {
        const optItem = $('<option value="' + a.id + '">' + a.name + '</option>');
        this.assetSelect.append(optItem);
      }.bind(this)
    );
  }

  initPreview () {
    // Preview
    this.previewContainer = $(
      '<div class="ca-vr_editorpanel-preview-container"></div>'
    );
    this.previewContainer.hide();
    this.panel.append(this.previewContainer);

    this.preview = $('<div class="ca-vr_editorpanel-preview"></div>');
    this.preview.hide();
    this.previewContainer.append(this.preview);

    // Prev
    this.prevAsset = $(
      '<div class="ca-vr_editorpanel-prev fa fa-chevron-left"></div>'
    );
    this.prevAsset.hide();
    this.previewContainer.append(this.prevAsset);
    this.prevAsset.on(
      'click',
      function () {
        let index = this.assetSelect.prop('selectedIndex') - 1;
        index = Math.max(index, 0);
        this.assetSelect.prop('selectedIndex', index).trigger('change');

        const asset = this.panelOpts.assets[this.assetSelect.prop('selectedIndex')];
        if (this.panelOpts.onAssetSwitch) { this.panelOpts.onAssetSwitch.call(this, asset); }
      }.bind(this)
    );

    // Next
    this.nextAsset = $(
      '<div class="ca-vr_editorpanel-next fa fa-chevron-right"></div>'
    );
    this.nextAsset.hide();
    this.previewContainer.append(this.nextAsset);
    this.nextAsset.on(
      'click',
      function () {
        let index = this.assetSelect.prop('selectedIndex') + 1;
        if (index >= this.panelOpts.assets.length) index = 0;
        this.assetSelect.prop('selectedIndex', index).trigger('change');

        const asset = this.panelOpts.assets[this.assetSelect.prop('selectedIndex')];
        if (this.panelOpts.onAssetSwitch) { this.panelOpts.onAssetSwitch.call(this, asset); }
      }.bind(this)
    );

    // Asset select
    this.assetPicker = new VRAssetPicker({
      icon: 'search-plus',
      assets: this.panelOpts.assets,
      asset: this.panelOpts.assets[0],
      addApplyAssetButton: this.panelOpts.addApplyAssetButton,
      onAssetSwitch: function () {
        const asset = this.panelOpts.assets[this.assetSelect.prop('selectedIndex')];
        if (this.panelOpts.onAssetSwitch) {
          this.panelOpts.onAssetSwitch.call(this, asset);
        }
      }.bind(this),
      onSelect: function (asset) {
        this.assetSelect
          .find('option[value="' + asset + '"]')
          .prop('selected', true)
          .trigger('change');
        if (this.panelOpts.addApplyAssetMessage !== '') {
          this.vr.showLoading(this.panelOpts.addApplyAssetMessage);
        }
      }.bind(this),
      onCreateItem: this.panelOpts.onCreateAssetItem
    });
    this.assetPicker.hide();
    this.panel.append(this.assetPicker.el);
  }

  updatePreview () {
    if (this.panelOpts.onAssetChange) {
      const index = this.assetSelect.prop('selectedIndex');
      const asset = this.panelOpts.assets[index];
      this.panelOpts.onAssetChange.call(this, asset);
    }
  }

  showPreview (show) {
    if (this.panelOpts.assets) {
      this.typeLabel.toggle(show);
      this.previewContainer.toggle(show);
      this.preview.toggle(show);
      this.prevAsset.toggle(show);
      this.nextAsset.toggle(show);
      this.assetPicker.el.toggle(show);
    }
  }

  initControls () {}

  open () {}

  close () {}

  newObject () {}

  setObject (obj) {
    // console.log(obj);
    this.selected = obj;

    if (!this.panelOpts.allowAddAsset) return;

    if (obj) {
      if (this.label) this.label.hide();
      if (this.addButton) this.addButton.hide();
      if (this.preview) this.showPreview(true);
      if (this.deleteContainer) this.deleteContainer.show();
    } else {
      if (this.label) this.label.show();
      if (this.addButton) this.addButton.show();
      if (this.preview) this.showPreview(false);
      if (this.deleteContainer) this.deleteContainer.hide();
    }
  }

  getObject () {
    return this.selected;
  }

  append (el) {
    this.panel.append(el);
  }

  createEditorCheckbox (id, name, checked) {
    const wrapper = $('<div></div>');
    this.append(wrapper);

    const checkbox = $(
      '<input id="ca-vr_editor-controls_' +
        id +
        '" type="checkbox"' +
        (checked ? ' checked' : '') +
        '></input>'
    );
    wrapper.append(checkbox);

    wrapper.append(
      $(
        '<label class="ca-vr_editor-controls_checklabel" for="ca-vr_editor-controls_' +
          id +
          '">' +
          name +
          '</label>'
      )
    );

    return checkbox;
  }
}
